import withInlineStylesAnchor from './withInlineStylesAnchor';

export { withInlineStylesAnchor };
